<app-form-box>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<app-form-label>Verify Account</app-form-label>
		<p>(check your email)</p>

		<br />

		<app-text-field
			[fg]="form"
			formGroupOrControlName="username"
			label="E-Mail"
			placeholder="E-Mail"
			autocomplete="username"
		></app-text-field>

		<br />

		<app-text-field
			[fg]="form"
			formGroupOrControlName="verificationCode"
			label="Verification Code"
			autocomplete="one-time-code"
		></app-text-field>

		<app-form-submit-button [disabled]="!form.valid || loading" [loading]="loading">
			Verify Account
		</app-form-submit-button>
	</form>

	<br />

	<div class="footer-links">
		<app-form-link (click)="onBack()">Back</app-form-link>
	</div>
</app-form-box>
